/* eslint-disable */
export default {
  title: 'Responder con mensajes de voz',
  customMessage: 'Mensaje personalizado',
  customMessagePlaceholder: 'Escribir un mensaje personalizado',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
